var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"goods"}},[_c('router-view'),_vm._v(" "),_c('div',{staticClass:"xian"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }